<template>
  <svg
    class="hadrian-icons man"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 12.298 30.259"
    style="enable-background: new 0 0 12.298 30.259"
    xml:space="preserve"
  >
    <g>
      <path
        d="M8.685,2.491c0,1.375-1.115,2.49-2.491,2.49c-1.375,0-2.491-1.115-2.491-2.49C3.704,1.115,4.819,0,6.195,0
		C7.57,0,8.685,1.115,8.685,2.491L8.685,2.491z M8.685,2.491"
      />
      <path
        d="M12.254,8.604c-0.008-1.56-1.283-2.829-2.844-2.829H2.888c-1.56,0-2.836,1.269-2.844,2.829L0,17.433
		c-0.003,0.664,0.532,1.204,1.195,1.207h0.006c0.661,0,1.198-0.534,1.202-1.195l0.044-7.947C2.455,9.353,2.577,9.24,2.722,9.244
		c0.145,0.004,0.26,0.123,0.26,0.268c0,2.966,0.001,18.641,0.001,19.305c0,0.796,0.645,1.442,1.442,1.442
		c0.797,0,1.442-0.646,1.442-1.442V17.291H6.49v11.526c0,0.796,0.645,1.442,1.442,1.442c0.796,0,1.442-0.646,1.442-1.442
		c0-5.399-0.025-13.719-0.026-19.315c0-0.138,0.111-0.251,0.25-0.252C9.735,9.249,9.848,9.36,9.851,9.498l0.044,7.947
		c0.003,0.662,0.541,1.196,1.202,1.196h0.006c0.664-0.003,1.199-0.544,1.196-1.208L12.254,8.604z M12.254,8.604"
      />
    </g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
  </svg>
</template>
